import { lazy, type ReactElement, Suspense } from "react";

import { DefaultErrorFallback } from "@/components/errors/DefaultErrorFallback";
import { ErrorPageBrandHeader } from "@/components/errors/ErrorPageBrandHeader";

const ErrorPageChrome = lazy(() =>
  import("@/components/errors/ErrorPageChrome").then((module) => ({
    default: module.ErrorPageChrome,
  })),
);

export interface RouteErrorFallbackProps {
  error?: Error | null;
}

function PageLoadError({ error }: RouteErrorFallbackProps): ReactElement {
  return <DefaultErrorFallback error={error} reset={() => window.location.reload()} />;
}

/** Route crash UI. The signed-in chrome loads separately so sign-in does not wait on it. */
export function RouteErrorFallback({ error }: RouteErrorFallbackProps): ReactElement {
  return (
    <Suspense
      fallback={
        <ErrorPageBrandHeader>
          <PageLoadError error={error} />
        </ErrorPageBrandHeader>
      }
    >
      <ErrorPageChrome>
        <PageLoadError error={error} />
      </ErrorPageChrome>
    </Suspense>
  );
}
